// Role helpers used across the app. Adjust the mappings if backend role codes change.
// Backend mapping: 3=Gerente, 4=Vendedor, 5=Estagiario. Admin and Master now come via boolean flags on user.
export const ROLE_MANAGER = 3
export const ROLE_SELLER = 4
export const ROLE_INTERN = 5

export type UserLike = { user_roles?: number | null; is_admin?: boolean | null; is_master?: boolean | null }

// Master: derived from user.is_master
export const isMasterRole = (user?: UserLike | null) => Boolean(user?.is_master)

// Admin: only when is_admin is true
export const isAdminRole = (user?: UserLike | null) => Boolean(user?.is_admin)

// Manager: only when user_roles == ROLE_MANAGER (3)
export const isManageRole = (user?: UserLike | null) => {
	if (!user) return false
	return Number(user.user_roles) === ROLE_MANAGER
}

// Attendant: only when user_roles == ROLE_SELLER (4). Admin/master must also have role 4 to count as attendant.
export const isAttendantRole = (user?: UserLike | null) => {
	if (!user) return false
	return Number(user.user_roles) === ROLE_SELLER
}
